export const RED = "#ee0a24"
export const BLUE = "#1989fa"
export const WHITE = "#fff"
export const GREEN = "#07c160"
export const ORANGE = "#ff976a"
export const GRAY = "#323233"
export const GRAY_DARK = "#969799"
